export * from './cross-storage.class';
